module.exports = __webpack_public_path__ + "static/img_2232-c7e0697fbd760e5bd2388d13ddea9b8b.webp";